import React from "react";
import { FormGroup, Input } from "reactstrap";

export const InputSwitcher = ({ isChecked, onChange, disabled, onClick }) => {
  return (
    <FormGroup switch>
      <Input
        type="switch"
        role="switch"
        checked={!!isChecked}
        onChange={onChange}
        disabled={disabled}
        onClick={onClick}
      />
    </FormGroup>
  );
};
